import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズのLaborCoreロゴアイコン
 */
export function ProductLogoSmallLaborCore({
  size = 20,
  color = '#0070C0',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M11.8535 6.25C11.8535 7.90685 10.5104 9.25 8.85352 9.25C7.19666 9.25 5.85352 7.90685 5.85352 6.25C5.85352 4.59315 7.19666 3.25 8.85352 3.25C10.5104 3.25 11.8535 4.59315 11.8535 6.25ZM13.3535 9.75H16.2929L17.8535 11.3107L17.8535 11.8333C17.8535 11.235 17.3685 10.75 16.7702 10.75H14.4368C13.8385 10.75 13.3535 11.235 13.3535 11.8333V9.75ZM17.8535 17.25H13.3535V15.1667C13.3535 15.765 13.8385 16.25 14.4368 16.25H16.7702C17.3685 16.25 17.8535 15.765 17.8535 15.1667L17.8535 17.25ZM13.3535 14.8333V12.1667C13.3535 12.765 13.8385 13.25 14.4368 13.25H16.7702C17.3685 13.25 17.8535 12.765 17.8535 12.1667V14.8333C17.8535 14.235 17.3685 13.75 16.7702 13.75H14.4368C13.8385 13.75 13.3535 14.235 13.3535 14.8333ZM6.10352 11.75H10.8535V15.75H3.10352C2.96544 15.75 2.85352 15.6381 2.85352 15.5V15C2.85352 13.2051 4.30859 11.75 6.10352 11.75Z"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}
